
<template>
  <div>
    <app-header
      v-bind:cmlUrl="cmlUrl"
    />
    <component
      v-bind:is="currentComponent"
      v-bind="currentProperties"
      @logged-in="loggedIn"
    />
    <app-footer />
  </div>
</template>

<script>
import Login from "./LoginFormComponent.vue";
import Form from "./RequestFormComponent.vue";
import Header from "./HeaderComponent.vue";
import Footer from "./FooterComponent.vue";

export default {
  name: "teacher-request",
  components: {
    Login,
    Form,
    'app-header': Header,
    'app-footer': Footer,
  },
  data() {
    return {
      currentComponent: "Login", // switch between components "Login" / "Form"
      patronData: {},
    };
  },
  props: ["loginUrl", "dataUrl", "cmlUrl"],
  computed: {
    currentProperties: function () {
      if (this.currentComponent === "Login") {
        return { 
          loginUrl: this.loginUrl,
          cmlUrl: this.cmlUrl
        };
      } else {
        return {
          dataUrl: this.dataUrl,
          patronData: this.patronData,
          cmlUrl: this.cmlUrl
        };
      }
    },
  },
  methods: {
    loggedIn(v) {
      this.currentComponent = v[0];
      this.patronData = v[1];
    },
  }
};
</script>
<style lang="css">
#app {
  margin: 1em;
  border-top: 1px solid #999;
}
.v-application {
  font-family: "Montserrat", sans-serif !important;
  line-height: 1.5;
}
.v-application--wrap{
  margin-left:auto;
  margin-right:auto;
  max-width:1000px !important;
}
h1 {
    padding-top: 10px !important;
}
.v-alert{
  margin-top: 16px !important;
}
.asterix {
  color: red;
}
.tc-button{
  margin-top: 15px !important;
  margin-bottom: 25px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
}
.submit-btn{
  background-color: #DB3B0F !important;
  border-color: #DB3B0F !important;
  color: #FFF !important;
}
.help-block {
  color: #737373;
}
p {
  font-size: 1em;
  font-weight:400;
}
.tc-subtitle {
  font-weight: 700;
}
.smalltext{
  font-size: 0.8em;
  font-weight: 700;
}
</style>